import {useEffect} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandListIcon} from "@pg-design/icons-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {useOnScreenObserver} from "../../atoms/chat_bot/feedback_popup/hooks/use_on_screen_observer";
import {VENDOR_REPORT_SECTION_ID} from "../../property/constants/vendor_report_section";
import {useVendorReportButton} from "../hooks/use_vendor_report_button";
import {hitGTMDeveloperReportView} from "../tracking/hit_gtm_developer_report";

interface IProps {
    vendorId: number;
}

export const VendorReportButton = (props: IProps) => {
    const {vendorId} = props;
    const {isMobile} = useUserDevice();
    const {handleClick, buttonText} = useVendorReportButton(vendorId);
    const {isOnScreen, startObserver, stopObserver} = useOnScreenObserver(VENDOR_REPORT_SECTION_ID);

    useEffect(() => {
        startObserver();
    }, []);

    useEffect(() => {
        if (isOnScreen) {
            hitGTMDeveloperReportView();
            stopObserver();
        }
    }, [isOnScreen]);

    return (
        <section id={VENDOR_REPORT_SECTION_ID}>
            <Button
                className={buttonStyle}
                iconLeft={BrandListIcon}
                variant="brand_icon"
                size={isMobile ? "medium" : "big"}
                onClick={handleClick}
                dataTestId={OFFER_TEST_IDS.OFFER_VIEW.DEVELOPER_REPORT_BUTTON}
            >
                {buttonText}
            </Button>
        </section>
    );
};

const buttonStyle = css({
    p: 0,

    md: {
        mb: 0,
        mr: 0
    }
});
import {useEffect} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandListIcon} from "@pg-design/icons-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {useOnScreenObserver} from "../../atoms/chat_bot/feedback_popup/hooks/use_on_screen_observer";
import {VENDOR_REPORT_SECTION_ID} from "../../property/constants/vendor_report_section";
import {useVendorReportButton} from "../hooks/use_vendor_report_button";
import {hitGTMDeveloperReportView} from "../tracking/hit_gtm_developer_report";

interface IProps {
    vendorId: number;
}

export const VendorReportButton = (props: IProps) => {
    const {vendorId} = props;
    const {isMobile} = useUserDevice();
    const {handleClick, buttonText} = useVendorReportButton(vendorId);
    const {isOnScreen, startObserver, stopObserver} = useOnScreenObserver(VENDOR_REPORT_SECTION_ID);

    useEffect(() => {
        startObserver();
    }, []);

    useEffect(() => {
        if (isOnScreen) {
            hitGTMDeveloperReportView();
            stopObserver();
        }
    }, [isOnScreen]);

    return (
        <section id={VENDOR_REPORT_SECTION_ID}>
            <Button
                className={buttonStyle}
                iconLeft={BrandListIcon}
                variant="brand_icon"
                size={isMobile ? "medium" : "big"}
                onClick={handleClick}
                dataTestId={OFFER_TEST_IDS.OFFER_VIEW.DEVELOPER_REPORT_BUTTON}
            >
                {buttonText}
            </Button>
        </section>
    );
};

const buttonStyle = css({
    p: 0,

    md: {
        mb: 0,
        mr: 0
    }
});
